import { get } from "./api";

export const getVinousReviewsForCellarSlugRequest = (slug: string) => {
  return get(`/vinousReviews/${slug}`);
};
